webpackJsonp([89515645794856],{

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(109);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpressPage = function ImpressPage(_ref) {
	    var data = _ref.data;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Impressum'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'b',
	                null,
	                'CODELINE.co'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'b',
	                null,
	                'Flo'
	            ),
	            ' Narr',
	            _react2.default.createElement('br', null),
	            'Ramsau 442',
	            _react2.default.createElement('br', null),
	            'A-6284 Ramsau'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'UID: AT-U69098889'
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'bigBack', to: '/' },
	            'Zur\xFCck'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'text-small' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Informationspflicht laut \xA75 E-Commerce Gesetz, \xA714 Unternehmensgesetzbuch, \xA763 Gewerbeordnung und Offenlegungspflicht laut \xA725 Mediengesetz siehe oben'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Angaben zur Online-Streitbeilegung: Verbraucher haben die M\xF6glichkeit, Beschwerden an die OnlineStreitbeilegungsplattform der EU zu richten: http://ec.europa.eu/odr. Sie k\xF6nnen allf\xE4llige Beschwerde auch an die oben angegebene E-Mail-Adresse richten.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Datenschutzerkl\xE4rung f\xFCr die Nutzung von Google Analytics'
	                ),
	                _react2.default.createElement('br', null),
	                'Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (\u201EGoogle\u201C). Google Analytics verwendet sog. \u201ECookies\u201C, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xF6glichen. Die durch den Cookie erzeugten Informationen \xFCber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xFCbertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europ\xE4ischen Union oder in anderen Vertragsstaaten des Abkommens \xFCber den Europ\xE4ischen Wirtschaftsraum zuvor gek\xFCrzt. Nur in Ausnahmef\xE4llen wird die volle IP-Adresse an einen Server von Google in den USA \xFCbertragen und dort gek\xFCrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xFCber die Websiteaktivit\xE4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xFCber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xFCbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xFChrt. Sie k\xF6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xE4mtliche Funktionen dieser Website vollumf\xE4nglich werden nutzen k\xF6nnen. Sie k\xF6nnen dar\xFCber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link (http://tools.google.com/dlpage/gaoptout?hl=de) verf\xFCgbare Browser-Plugin herunterladen und installieren. N\xE4here Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter http://www.google.com/analytics/terms/de.html bzw. unter https://support.google.com/analytics/answer/6004245?hl=de. Wir weisen Sie darauf hin, dass auf dieser Webseite Google Analytics um den Code \u201Egat._anonymizeIp();\u201C erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu gew\xE4hrleisten.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Datenschutzerkl\xE4rung'
	                ),
	                _react2.default.createElement('br', null),
	                'Angaben zur Online-Streitbeilegung: Verbraucher haben die M\xF6glichkeit, Beschwerden an die OnlineStreitbeilegungsplattform der EU zu richten: http://ec.europa.eu/odr. Sie k\xF6nnen allf\xE4llige Beschwerde auch an die oben angegebene E-Mail-Adresse richten.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Wir legen gro\xDFen Wert auf den Schutz Ihrer Daten. Um Sie in vollem Umfang \xFCber die Verwendung personenbezogener Daten zu informieren, bitten wir Sie die folgenden Datenschutzhinweise zur Kenntnis zu nehmen.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Pers\xF6nliche Daten'
	                ),
	                _react2.default.createElement('br', null),
	                'Pers\xF6nliche Daten, die Sie auf dieser Website elektronisch \xFCbermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder andere pers\xF6nlichen Angaben, werden von uns nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben. Der Provider erhebt und speichert automatisch Informationen am Webserver wie verwendeter Browser, Betriebssystem, Verweisseite, IP-Adresse, Uhrzeit des Zugriffs usw. Diese Daten k\xF6nnen ohne Pr\xFCfung weiterer Datenquellen keinen bestimmten Personen zugeordnet werden und wir werten diese Daten auch nicht weiter aus solange keine rechtswidrige Nutzung unserer Webseite vorliegt.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Formulardaten und Kommentare'
	                ),
	                _react2.default.createElement('br', null),
	                'Wenn Webseitenbesucher Kommentare oder Formulareintr\xE4ge hinterlassen, werden die eingegebenen Daten und ihre IP-Adressen gespeichert. Das erfolgt zur Sicherheit, falls jemand widerrechtliche Inhalte verfasst (Beleidigungen, links- oder rechtsextreme Propaganda, Hasspostings usw.). In diesem Fall sind wir an der Identit\xE4t des Verfassers interessiert.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Cookies'
	                ),
	                _react2.default.createElement('br', null),
	                'Cookies sind kleine Dateien, die es dieser Webseite erm\xF6glichen auf dem Computer des Besuchers spezifische, auf den Nutzer bezogene Informationen zu speichern, w\xE4hrend unsere Website besucht wird. Cookies helfen uns dabei, die Nutzungsh\xE4ufigkeit und die Anzahl der Nutzer unserer Internetseiten zu ermitteln, sowie unsere Angebote f\xFCr Sie komfortabel und effizient zu gestalten. Wir verwenden einerseits Session-Cookies, die ausschlie\xDFlich f\xFCr die Dauer Ihrer Nutzung unserer Website zwischengespeichert werden und zum anderen permanente Cookies, um Informationen \xFCber Besucher festzuhalten, die wiederholt auf unsere Website zugreifen. Der Zweck des Einsatzes dieser Cookies besteht darin, eine optimale Benutzerf\xFChrung anbieten zu k\xF6nnen sowie Besucher wiederzuerkennen und bei wiederholter Nutzung eine m\xF6glichst attraktive Website und interessante Inhalte pr\xE4sentieren zu k\xF6nnen. Der Inhalt eines permanenten Cookies beschr\xE4nkt sich auf eine Identifikationsnummer. Name, IP-Adresse usw. werden nicht gespeichert. Eine Einzelprofilbildung \xFCber Ihr Nutzungsverhalten findet nicht statt. Eine Nutzung unserer Angebote ist auch ohne Cookies m\xF6glich. Sie k\xF6nnen in Ihrem Browser das Speichern von Cookies deaktivieren, auf bestimmte Webseiten beschr\xE4nken oder Ihren Webbrowser (Chrome, IE, Firefox,\u2026) so einstellen, dass er sie benachrichtigt, sobald ein Cookie gesendet wird. Sie k\xF6nnen Cookies auch jederzeit von der Festplatte ihres PC l\xF6schen. Bitte beachten Sie aber, dass Sie in diesem Fall mit einer eingeschr\xE4nkten Darstellung der Seite und mit einer eingeschr\xE4nkten Benutzerf\xFChrung rechnen m\xFCssen.'
	            )
	        )
	    );
	};
	
	exports.default = ImpressPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impress-js-256d6a33b7445a43f39f.js